export const ImageComponent = ({ src, alt }) => {
  return (
    <div className="imageComponent">
      <img src={src} alt={alt}></img>
    </div>
  );
};
